
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { component as Viewer } from 'v-viewer';
import { IImage } from '@/common/interface';
import ShopService from '@/services/shop.service';
import lazyInject from '@/di';

@Component({
  components: {
    Viewer,
  },
})
export default class BossIdImagesField extends Vue {
  val: IImage[] = [];

  idCardInfo: any = {};

  @lazyInject(ShopService)
  shopService!: ShopService;

  @Prop()
  readonly!: boolean;

  @Prop()
  disabled!: boolean;

  @Prop()
  value!: IImage[];

  @Prop()
  label!: string;

  @Prop()
  idInfo!: number;

  @Watch('value')
  async watchValue() {
    if (this.value.length) {
      this.val = [...this.value];
      if (this.label === 'bossIdImage' || this.label === 'managerId') {
        // if (this.idInfo) {
          this.idCardInfo = this.idInfo;
        // }
      }
    } else {
      this.val = [];
    }
  }

  mounted() {
    this.watchValue();
  }
}
